
import { legoPerf } from '@zz-common/lego'
import './skeleton'

try {
  legoPerf()
} catch (err) {
  console.warn(err)
}

window.onload = function () {
  import('./entry')
}
